import { iChromiaState } from "../../interfaces/chrInterfaces";
import { eChromiaActionTypes, tChromiaAction } from "./chromiaTypes";

const initial_state: iChromiaState = {
	chrUserAddress: null,
	tokenBalances: [],
	expiredOptions: [],
	gtxClient: null,
	session: null,
	params: null,
	isIniting: false
}

export const chromiaReducer = ( state = initial_state, action: tChromiaAction) : iChromiaState => {
	switch (action.type){

		case eChromiaActionTypes.CLEAR_STATE:
			return {
				...initial_state,
				params: state.params
			}
		;

		/* case eChromiaActionTypes.SET_ACCOUNT_DETAILS:
			return {...state, ...action.payload}
		; */

		case eChromiaActionTypes.SET_CHR_USER_ADDRESS:
			return {...state, chrUserAddress: action.payload}
		;

		case eChromiaActionTypes.SET_TOKEN_BALANCES:
			return {...state, tokenBalances: action.payload}
		;

		case eChromiaActionTypes.SET_EXPIRED_OPTIONS:
			return {...state, expiredOptions: action.payload}
		;

		case eChromiaActionTypes.SET_GTX_CLIENT:
			return {...state, gtxClient: action.payload}
		;

		case eChromiaActionTypes.SET_SESSION:
			return {...state, session: action.payload}
		;

		case eChromiaActionTypes.SET_PARAMS:
			return {...state, params: action.payload}
		;

		case eChromiaActionTypes.SET_IS_INITING:
			return {...state, isIniting: action.payload}
		;

		default: return state;
	}
}